import React from "react";
import EditFitoutBannerForm from "../Components/Pages/EditFitoutBanner/EditFitoutBannerForm";

function EditFitoutBanner() {
  return (
    <div className="p-9">
      <EditFitoutBannerForm />
    </div>
  );
}

export default EditFitoutBanner;